import { combineReducers } from '@reduxjs/toolkit';
import { reducer as tableReducer } from 'src/slices/tableSettings';

const rootReducer = combineReducers({
  tableSettings: tableReducer,
});

export default rootReducer;
